export default {
      fr: {
            GLOBAL: {
                  title: '',
            },
      },
      en: {
            GLOBAL: {
                  title: '',        
            },
      }
}


